import { type TaskType } from "./useTaskCreation";

export function isPublicationTaskType(taskType: TaskType): boolean {
  return taskType === "homepage_publication" || taskType === "sitewide_publication";
}
